import {
  ENFORCE_MFA_SETUP_LANDING,
  OTP_LOGIN,
  RECOVERY_CODE_LOGIN,
} from '@hotjar/webapp/constants/routes/mfa';

export const getTargetUrl = (path: string, next?: string): URL => {
  const targetUrl = new URL(window.location.href);
  targetUrl.pathname = path;
  targetUrl.search = '';

  if (next) {
    targetUrl.searchParams.set('next', next);
  }
  return targetUrl;
};

export const redirectMfaSetup = (next?: string): void => {
  const targetUrl = getTargetUrl(ENFORCE_MFA_SETUP_LANDING.path, next);
  window.location.assign(targetUrl.href);
};

export const getLoginOtpURL = (state: string, next?: string): URL => {
  return getTargetUrl(OTP_LOGIN.path.replace(':state', state), next);
};

export const redirectLoginOtp = (state: string, next?: string): void => {
  window.location.assign(getLoginOtpURL(state, next).href);
};

export const getRecoveryCodeURL = (state: string, next?: string): URL => {
  return getTargetUrl(RECOVERY_CODE_LOGIN.path.replace(':state', state), next);
};

export const redirectRecoveryCode = (state: string, next?: string): void => {
  window.location.assign(getRecoveryCodeURL(state, next).href);
};
